/* Mobile smartBanner define */
(function closure(root, factory) {
  /* istanbul ignore else  */
  if (typeof define === 'function' && define.amd) {
    define('footer.pcLink', ['jquery', 'cookie-utils'],
      function load(jQuery, cookieUtils) {
        return factory(root, jQuery, cookieUtils);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.pcLink = factory(root, jQuery, cookieUtils);
    /*eslint-enable*/
  }
})(this, function factory(root, $, cookieUtils) {
  var module = {};


  privateMethods = {};

  privateMethods.clickHandler = function(e) {

    e.preventDefault();

    if(THD_GLOBAL.channel === 'web' && cookieUtils.hasBrowserCookie("THD_USR_AGENT_OVERRIDE")){
      cookieUtils.deleteBrowserCookie('THD_USR_AGENT_OVERRIDE', THD_GLOBAL.cookie_domain);
    }else if(THD_GLOBAL.channel === 'mobile'){
      cookieUtils.setCookieExpireInSeconds('THD_USR_AGENT_OVERRIDE', 'FULL', 18000, THD_GLOBAL.cookie_domain);
      cookieUtils.deleteBrowserCookie('THD_ONLINE_CHANNEL', THD_GLOBAL.cookie_domain);
      cookieUtils.deleteBrowserCookie('MOBILE_WEB', THD_GLOBAL.cookie_domain);
    }

    var pcSiteUrl = '';
    var absoluteUrlPattern = /^https?:\/\//i;
    if (typeof(THD_GLOBAL.deepLinkUrl) === 'undefined') {
      pcSiteUrl = $(this).data('href');
    } else if (!absoluteUrlPattern.test(THD_GLOBAL.deepLinkUrl)) {
      pcSiteUrl = $(this).data('href') + THD_GLOBAL.deepLinkUrl;
    } else {
      pcSiteUrl = THD_GLOBAL.deepLinkUrl;
    }

    privateMethods.linkHandler(pcSiteUrl);

  };

  /* istanbul ignore next  */
  privateMethods.linkHandler = function(url) {
    window.location.href = url;
  }

  module.init = function _init() {
    $(document).on('click', '#linkPcSite', privateMethods.clickHandler);
  };

  module.getPrivateMethods = function(){
    return privateMethods;
  };

  return module;
});
